import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { PharmaceuticalFormAutoUploadEntity } from "../Entity/PharmaceuticalFormAutoUploadEntity";
import { BaseNode } from "../../BaseNode";
import { environment } from "../../../../../../environments/environment";
import { OnDemandArt57NodeList } from "./OnDemandArt57NodeList";


export class TreeNodeMedicinalProductPharmaceuticalProducts extends OnDemandArt57NodeList{
    items: any;
    cloningNode: boolean = false;
    useHist: boolean = false;

    constructor(injector: Injector, parent: any,useHist: boolean, cloningNode: boolean, items: any[]|undefined) {
        super(injector, new ListView(), `Pharmaceutical Products (${items?items.length:'-'})`);
        this.parent = parent;
        this.cloningNode = cloningNode;
        this.useHist = useHist;
        this.labelNodeName = 'Pharmaceutical Products'
        this.items = items;
        
        if (this.cloningNode) {
            return;
        }

        for (const item of items || []) {
            const labelTemplate = `${item.name_Pharmform}`;
            this.children?.push(new PharmaceuticalFormAutoUploadEntity(injector,labelTemplate,this,item,this.useHist,true, false));            
        }

    }

    override getHeaders(): string[] {
        return ['Administrable Pharmaceutical Form Name'];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeMedicinalProductPharmaceuticalProducts = new TreeNodeMedicinalProductPharmaceuticalProducts(this.ioc!,newParent, false,true, this.items);        
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
   
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });

      clonedNode.cloningNode = false;
      return clonedNode;
    }    

    override getOnDemandEntities() {
        let entitiesArray:any[] = super.getOnDemandEntities();
        // check if not empy array then set the name for JSON
        if(entitiesArray.length>0) {
            return {pharmaceuticalproducts:{pharmaceuticalproduct: entitiesArray}};
        }
        
        return {};
    }

}